module.exports = __webpack_public_path__ + "img/cf.d5c6b378.svg";